/**
 * Bonus status list
 */
export enum BonusStatus {
  NEW = 'NEW',
  ACTIVE = 'ACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  FREESPIN_IN_PROGRESS = 'FREESPIN_IN_PROGRESS',
  FREESPIN_RELEASED = 'FREESPIN_RELEASED',
  RELEASED = 'RELEASED',
  CANCELED = 'CANCELED',
  ACTIVATION_EXPIRED = 'ACTIVATION_EXPIRED',
  USAGE_EXPIRED = 'USAGE_EXPIRED',
  WAGERING_USAGE_EXPIRED = 'WAGERING_USAGE_EXPIRED',
  OPENED = 'OPENED',
  OPENING_EXPIRED = 'OPENING_EXPIRED',
}

/**
 * Bonus types
 */
export enum BonusType {
  CASH = 'CASH',
  FREESPIN = 'FREESPIN',
  DEPOSIT = 'deposit',
  LOOTBOX = 'LOOTBOX'
}

/**
 * Text labels for bonus stages
 */
export const BonusStatusLabel = {
  [BonusStatus.CANCELED]: 't.canceled',
  [BonusStatus.NEW]: 't.issued',
  [BonusStatus.IN_PROGRESS]: 't.in-progress',
  [BonusStatus.FREESPIN_IN_PROGRESS]: 't.in-progress',
  [BonusStatus.FREESPIN_RELEASED]: 't.finished',
  [BonusStatus.ACTIVATION_EXPIRED]: 't.expired',
  [BonusStatus.USAGE_EXPIRED]: 't.expired',
  [BonusStatus.OPENING_EXPIRED]: 't.expired',
  [BonusStatus.WAGERING_USAGE_EXPIRED]: 't.expired',
  [BonusStatus.ACTIVE]: 't.activated',
  [BonusStatus.OPENED]: 't.activated',
  [BonusStatus.RELEASED]: 't.finished',
};

/**
 * Bonus action
 */
export enum BonusAction {
  ACTIVATE = 'ACTIVATE',
  CANCEL = 'CANCEL',
}

export enum DepositBonusAlias {
  DEPOSIT1 = 'deposit1',
  DEPOSIT2 = 'deposit2',
  DEPOSIT3 = 'deposit3',
}
